import script from "./RechargeVip.vue?vue&type=script&setup=true&lang=js"
export * from "./RechargeVip.vue?vue&type=script&setup=true&lang=js"

import "./RechargeVip.vue?vue&type=style&index=0&id=7a8a92b6&lang=css"
import "./RechargeVip.vue?vue&type=style&index=1&id=7a8a92b6&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8a92b6"]])

export default __exports__